export const DEFAULT_ANIMATION = 'none';
export const DEFAULT_ENVELOPE_COLOR = '#FFFFFF';
export const DEFAULT_BACKGROUND_COLOR = '#F7F7F7';

export const DIGITAL_WALLPAPER_COLORS = [
  {
    value: '#FFFFFF',
  },
  {
    value: '#F4F2EC',
  },
  {
    value: '#FFE9E9',
  },
  {
    value: '#CCB99A',
  },
  {
    value: '#494949',
  },
  {
    value: '#D8E897',
  },
  {
    value: '#C5D0BF',
  },
  {
    value: '#3D4D41',
  },
  {
    value: '#D2E1F3',
  },
  {
    value: '#5176B0',
  },
  {
    value: '#263E5C',
  },
  {
    value: '#DED0E5',
  },
  {
    value: '#553E75',
  },
  {
    value: '#E7524D',
  },
  {
    value: '#6B0D2E',
  },
  {
    value: '#FFED93',
  },
  {
    value: '#F6881A',
  },
  {
    value: '#BA5D3E',
  },
  {
    value: '#876554',
  },
];

export const DIGITAL_ENVELOPE_COLORS = [
  {
    value: '#FFFFFF',
  },
  {
    value: '#F8E8D2',
  },
  {
    value: '#E1E1E1',
  },
  {
    value: '#F9D6CE',
  },
  {
    value: '#494949',
  },
  {
    value: '#C3DE5A',
  },
  {
    value: '#86C150',
  },
  {
    value: '#778B71',
  },
  {
    value: '#D2E1F3',
  },
  {
    value: '#A7D1D9',
  },
  {
    value: '#4784B5',
  },
  {
    value: '#263E5C',
  },
  {
    value: '#CCB9D6',
  },
  {
    value: '#FFA6C5',
  },
  {
    value: '#9D1E4B',
  },
  {
    value: '#CA0919',
  },
  {
    value: '#FFB33E',
  },
  {
    value: '#BA5D3E',
  },
  {
    value: '#A88165',
  },
];

export const DIGITAL_ENVELOPE_ANIMATIONS = [
  {
    label: 'Party time! 🎉',
    value: 'confetti',
  },
  {
    label: 'None',
    value: 'none',
  },
];
